import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import ReactHtmlParser from 'react-html-parser';

import { Icon } from 'semantic-ui-react';

import * as common from 'libs/commonFunc';
import { LoginTemplate, Logo, ButtonLink, Button } from 'components';

import styles from './NoActive.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

// 비활성화 계정 체크
class NoActive extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { isLoading, userEmail, loginResult, loginMessage, noActiveLogin, reSendMail, isReSendMail } = this.props;
    return (
      <LoginTemplate>
        <div className={cx('noActive')}>
          <div className={cx('info-area')}>
            <div className={cx('info-1')}>
              {ReactHtmlParser(
                defineMessages(
                  formatMessage({
                    id: 'NoActive_1',
                    defaultMessage:
                      "해당 계정은 <span className={cx('bold')}>이메일 인증이 이루어지지 않은 계정</span>입니다."
                  })
                )
              )}
            </div>
            <div className={cx('info-2')}>
              {defineMessages(
                formatMessage({ id: 'NoActive_2', defaultMessage: '계정을 활성화해서 MudFix를 이용하세요' })
              )}
            </div>

            <div className={cx('info-3')}>
              <div className={cx('info-4')}>
                <span className={cx('info-6')}>
                  {defineMessages(formatMessage({ id: 'NoActive_5', defaultMessage: '등록된 메일 주소' })) + ' '}
                </span>
                <span className={cx('bold')}>{userEmail}</span>
              </div>
              <div className={cx('info-5')}>
                <span>{defineMessages(formatMessage({ id: 'NoActive_3', defaultMessage: '남은 기간' })) + ' '}</span>
                <span className={cx('bold')}>
                  {loginResult === 32
                    ? common.timeDiffFromUTCEpoch(loginMessage)
                    : defineMessages(formatMessage({ id: 'NoActive_4', defaultMessage: '만료' }))}
                </span>
              </div>
            </div>
          </div>
          <div className={cx('button-area')}>
            {loginResult === 32 && (
              <Button className={cx('bt-brand')} loading={isLoading} disabled={isLoading} onClick={noActiveLogin}>
                {defineMessages(formatMessage({ id: 'NoActive_6', defaultMessage: '다음에 인증하기' }))}
              </Button>
            )}
            <Button className={cx('bt-grey mt-10')} loading={isLoading} disabled={isLoading} onClick={reSendMail}>
              {defineMessages(formatMessage({ id: 'NoActive_7', defaultMessage: '인증메일 재전송' }))}
            </Button>
            {!!isReSendMail && (
              <div className={cx('reSendMailMessage', { 'color-red': isReSendMail === 2 })}>
                {isReSendMail === 1
                  ? defineMessages(formatMessage({ id: 'NoActive_8', defaultMessage: '메일 재전송 성공' }))
                  : defineMessages(formatMessage({ id: 'NoActive_9', defaultMessage: '메일 재전송 실패' }))}
              </div>
            )}
          </div>
        </div>
      </LoginTemplate>
    );
  }
}

NoActive.propTypes = {
  userEmail: PropTypes.string,
  visible: PropTypes.bool,
  loginResult: PropTypes.number,
  loginMessage: PropTypes.string,
  noActiveLogin: PropTypes.func,
  reSendMail: PropTypes.func
};

export default injectIntl(NoActive);



// WEBPACK FOOTER //
// ./src/script/components/login/NoActive.js